import { Link } from "react-router-dom";
import { FiArrowRight, FiAlertTriangle } from "react-icons/fi";
import useFetch from "../hook/useFetch.jsx";
import Product from "./Product.jsx";
import ProductGrid from "./ProductGrid.jsx";
import SectionHeader from "./SectionHeader.jsx";
import ProductGridSkeleton from "./ui/ProductGridSkeleton.jsx";
import StateMessage from "./ui/StateMessage.jsx";

export default function LatestProducts() {
  const { data, isLoading, error } = useFetch(
    "/products/products?isNewProduct=true"
  );
  const products = Array.isArray(data) ? data.slice(0, 7) : [];

  return (
    <section className="mb-20">
      <div className="container mx-auto">
        <SectionHeader title="Popular Products" />
        {isLoading ? (
          <ProductGridSkeleton count={8} />
        ) : error ? (
          <StateMessage
            icon={FiAlertTriangle}
            title="Couldn't load products"
            message="Please try again later."
          />
        ) : (
          <ProductGrid>
            {products.map((product) => (
              <Product product={product} key={product._id} />
            ))}
            {/* browse more tile */}
            <Link
              to="/"
              className="card flex flex-col items-center justify-center text-center gap-y-2 hover:border-brand/40 hover:text-brand transition-colors text-ink min-h-[300px]">
              <span className="font-display text-xl font-medium">Browse</span>
              <span className="inline-flex items-center gap-x-2 text-muted">
                More <FiArrowRight />
              </span>
            </Link>
          </ProductGrid>
        )}
      </div>
    </section>
  );
}
